import React from 'react';
import { motion } from 'framer-motion';
import { FaMobile, FaGraduationCap, FaCogs, FaExternalLinkAlt } from 'react-icons/fa';
import './Solutions.css';

const Solutions = () => {
  const solutions = [
    {
      id: 1,
      icon: <FaMobile />,
      title: "Aplicativo de coleta de dados em campo",
      description: "Solução completa para coleta de dados em campo com sincronização offline, GPS e relatórios em tempo real.",
      features: ["Coleta online eoffline", "Formulários personalizados", "Relatórios automáticos", "Exportação de dados"],
      badges: ["Offline", "Geolocalização", "Integrações com outros sistemas"],
      mockup: "https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80",
      link: "#",
      color: "#00AFEF"
    },
    {
      id: 2,
      icon: <FaGraduationCap />,
      title: "Sistema de avaliação para professores",
      description: "Plataforma educacional para gestão de avaliações, notas e acompanhamento do desempenho dos alunos.",
      features: ["Gestão de notas", "Relatórios de desempenho", "Criação e correção de avaliações", "Auxílio de IA"],
      badges: ["Inteligência Artificial", "Relatórios", "Controle de desempenho"],
      mockup: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80",
      link: "#",
      color: "#0081A5"
    },
    {
      id: 3,
      icon: <FaCogs />,
      title: "Sistema de gestão operacional de ativos",
      description: "Solução para controle e manutenção de ativos empresariais com planejamento preventivo e corretivo.",
      features: ["Controle de ativos", "Manutenção preventiva", "Gestão de custos", "Relatórios operacionais"],
      badges: ["Gestão", "Manutenção", "Relatórios"],
      mockup: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2015&q=80",
      link: "#",
      color: "#606062"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6
      }
    }
  };

  const handleSolutionClick = (link) => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="solucoes" className="section solutions-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Soluções</h2>
          <p className="section-subtitle">Conheça algumas de nossas soluções desenvolvidas para atender necessidades específicas do mercado</p>
        </motion.div>

        <motion.div
          className="solutions-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {solutions.map((solution) => (
            <motion.div
              key={solution.id}
              className="solution-card"
              variants={cardVariants}
              whileHover={{ y: -10, scale: 1.02 }}
              onClick={() => handleSolutionClick(solution.link)}
            >
              <div className="solution-mockup">
                <img src={solution.mockup} alt={solution.title} loading="lazy" />
                <div className="solution-overlay">
                  <FaExternalLinkAlt />
                </div>
              </div>
              
              <div className="solution-content">
                <div className="solution-header">
                  <div 
                    className="solution-icon"
                    style={{ backgroundColor: solution.color }}
                  >
                    {solution.icon}
                  </div>
                </div>
                
                <h3 className="solution-title">{solution.title}</h3>
                <p className="solution-description">{solution.description}</p>
                
                <div className="solution-badges">
                  {solution.badges.map((badge, index) => (
                    <span key={index} className="solution-badge">
                      {badge}
                    </span>
                  ))}
                </div>
                
                <ul className="solution-features">
                  {solution.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
                
                <div className="solution-cta">
                  <span>Conhecer solução</span>
                  <FaExternalLinkAlt />
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="solutions-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <p>Precisa de uma solução personalizada?</p>
          <button 
            className="btn btn-primary"
            onClick={() => {
              const element = document.getElementById('contato');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            Entre em contato
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Solutions; 